import DummyText from "./utils/DummyText";
import Navigation from "./components/Navigation";
import Products from "./components/Products";
import Product from "./components/Product";
import Sliders from "./components/Sliders";
import TopBar from "./components/MobleTopBar";
import Cart from "./components/ShoppingCart";

import { Popover } from "bootstrap";

import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// import { forEach } from "core-js/core/array";

export default class Common {
  constructor() {
    // 靜態變量用來追蹤是否已經綁定過事件
    this.qtyDelegationBound = false;
  }

  init() {
    gsap.registerPlugin(ScrollToPlugin);
    this.initDummyText();
    this.initNavigation();
    this.initProduct();
    this.initProducts();
    this.initSliders();
    this.initMobileTopBar();
    this.backToTop();
    this.pageAutoScrollTo()
    this.shoppingCartControl();
    this.qtyControl();
    this.handlePopovers()
    this.handlePageLoader()
  }

  initDummyText() {
    let dummyText = document.querySelectorAll("[js-dummytext]");
    for (let dt of dummyText) {
      new DummyText(dt);
    }
  }

  initNavigation() {
    let navDOM = document.querySelector("nav");
    if (navDOM) {
      let partNav = new Navigation(navDOM);
    }
  }

  initProduct() {
    let productDIV = document.querySelectorAll(".single-product");
    if (productDIV.length) {
      let product = new Product(productDIV);
      product.init();
    }
  }

  initProducts() {
    let products = document.querySelectorAll(".products");
    for (let pd of products) {
      new Products(pd);
    }
  }

  initSliders() {
    // let allSliders = document.querySelectorAll(".swiper");
    // for (let sl of allSliders) {
    //   new Sliders(sl);
    // }
    new Sliders(document);
  }

  initMobileTopBar() {
    let topBar = document.querySelector("[js-top-bar]");
    new TopBar(topBar);
  }

  backToTop() {
    const bbtBtn = document.querySelector(".backtotop");
    const scrollDiv = document.querySelector(".m-top-bar");
    // scroll

    if (bbtBtn && scrollDiv) {
      // const scrollDiv = document.querySelector(".m-top-bar");
      const pos = scrollDiv.scrollTop;

      bbtBtn.addEventListener("click", () => {
        // console.log("click");
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
      const ob = new IntersectionObserver(obCallback);
      function obCallback(scrollDiv) {
        if (scrollDiv[0].boundingClientRect.y < 0) {
          bbtBtn.classList.toggle("visible");
        } else {
        }
      }
      ob.observe(scrollDiv);
    }
  }

  pageAutoScrollTo() {
    const auto_scrollTo = document.querySelector("[auto-scrollto]")?.getAttribute('auto-scrollto');
    if (auto_scrollTo) {
      let scroll_target = `#${auto_scrollTo}`;
      if (window.location.hash) {
        scroll_target = window.location.hash;
      }
      setTimeout(() => {
        gsap.to(window, { duration: .75, scrollTo: { y: scroll_target, offsetY: 100 } });
      }, 500)
    }
  }

  shoppingCartControl() {
    let cartPage = document.querySelector('#page-cart');
    let cart = document.querySelector(".cart");
    if(cart && !cartPage){
      new Cart(cart);
      document.querySelectorAll('.shCart button.del-btn, .shCart button.qty-btn').forEach((item, i) => {
        item.classList.add('d-none')
        item.disabled = true
      });

    }
  }

  handlePopovers() {
    const popoverTriggerList = document.querySelectorAll(
      '.p_colours--item[data-bs-toggle="popover"]'
    );
    const popoverList = [...popoverTriggerList].map(
      (popoverTriggerEl) => new Popover(popoverTriggerEl)
    );
  }

  handlePageLoader() {
    let pageLoader = document.querySelector('.page-loader')
    const custProductPage = document.querySelector("#page-cust-product");
    const custProductPageW = document.querySelector("#page-cust-product-workshop");

    if (pageLoader && (!custProductPage && !custProductPageW)) {
      gsap.to(pageLoader, {
        opacity: 0,
        duration: .35,
        delay: .5,
        onComplete: () => {
          pageLoader.remove()
        }
      })
    }
  }
  
  qtyControl() {
    // 使用靜態變量檢查是否已經綁定過事件委託
    if (Common.qtyDelegationBound) {
      return; // 已經綁定過了
    }
    Common.qtyDelegationBound = true;

    document.addEventListener('click', (e) => {
      // 檢查點擊的是否為數量控制按鈕
      if (!e.target.matches('.qty-plus, .qty-minus')) {
        return;
      }

      const button = e.target;
      const qtyContainer = button.closest('.qty');
      if (!qtyContainer) return;

      const input = qtyContainer.querySelector("[js-qty-input]");
      if (!input) return;

      // 阻止事件冒泡和預設行為，避免其他監聽器被觸發
      e.preventDefault();
      e.stopImmediatePropagation();

      const min = Number(input.getAttribute("min")) || 0;
      const max = Number(input.getAttribute("max")) || 99;
      const step = Number(input.getAttribute("step")) || 1;
      let current = Number(input.value);
      let oldValue = current;

      if (button.classList.contains('qty-plus')) {
        let newval = current + step;
        console.log("trigger" + newval);
        if (newval > max) newval = max;
        input.value = Number(newval);
      } else if (button.classList.contains('qty-minus')) {
        let newval = current - step;
        if (newval < min) {
          newval = min;
        } else if (newval > max) {
          newval = max;
        }
        input.value = Number(newval);
      }

      // 如果值有變化，手動觸發 change 事件
      if (oldValue !== Number(input.value)) {
        const changeEvent = new Event('change', { bubbles: true });
        input.dispatchEvent(changeEvent);
      }
    }, true); // 使用捕獲階段，確保這個監聽器最先執行
  }
  
}

// 靜態變量用來追蹤是否已經綁定過 qty 事件委託
Common.qtyDelegationBound = false;
